import { Image } from '@/api/image';
import { MemberType } from '@/api/members';
import { OrganizationType } from '@/api/organizations';
import { createSlice } from '@reduxjs/toolkit';

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        organization: {},
        member: {},
        portrait: null,
        logo: null,
        role: ''
    },
    reducers: {
        setMember: (state, action) => {
            state.member = action.payload;
        },
        setPortrait: (state, action) => {
            state.portrait = action.payload;
        },
        setOrganization: (state, action) => {
            state.organization = action.payload;
        },
        setLogo: (state, action) => {
            state.logo = action.payload;
        },
        setRole: (state, action) => {
            state.role = action.payload;
        },
    },
})

// Action creators are generated for each case reducer function
export const { setMember, setPortrait, setOrganization, setLogo, setRole } = authSlice.actions

export const getMember = (state: any) => state.auth.member as MemberType
export const getPortrait = (state: any) => state.auth.portrait as Image
export const getOrganization = (state: any) => state.auth.organization as OrganizationType
export const getLogo = (state: any) => state.auth.logo as Image
export const getRole = (state: any) => state.auth.role as string

export default authSlice.reducer